/* eslint-disable react/prop-types */
import React, { useRef } from 'react';

const InputFile = ({ children, onChange }) => {
    const hiddenFileInput = useRef(null);

    const handleClick = () => {
        hiddenFileInput.current.click();
    };
    const handleChange = event => {
        const fileUploaded = event.target.files[0];
        onChange(fileUploaded);
    };

    return (
        <>
            <button className="btn-clear" onClick={handleClick}>
                {children || 'Upload a file'}
            </button>
            <input
                type="file"
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{ display: 'none' }}
            />
        </>
    );
};
export default InputFile;
